import React, { memo } from 'react';
import HBDropdown, { IDropdown } from '../HBDropdown/HBDropdown';
import { TOptionValue } from '../HBDropdown/HBDropdown.types';
import HBBaseFormField, {
    HBBaseFormFieldProps,
    splitFieldProps
} from '../HBBaseFormField/HBBaseFormField';

export type HBDropdownFieldProps<Value = TOptionValue> = Omit<
    HBBaseFormFieldProps,
    'htmlFor'
> &
    IDropdown<Value> & {
        /** HTML `id` for the field; used as the `<label htmlFor>` target and the accessible name for the dropdown control. Required. */
        id: string;
    };

const HBDropdownField = <Value extends TOptionValue>({
    size = 'sm',
    ...props
}: HBDropdownFieldProps<Value>) => {
    const { fieldProps, inputProps } = splitFieldProps(props);

    return (
        <HBBaseFormField {...fieldProps} size={size}>
            <HBDropdown {...inputProps} size={size} />
        </HBBaseFormField>
    );
};

export default memo(HBDropdownField) as typeof HBDropdownField;
